import Editor from '@monaco-editor/react';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import { IPrimitiveStore } from '../../../../../common/store/interface/IPrimitiveStore';
import { IFileOption, ITaskLanguage } from '../../../../../service/unit/interface/IUnitPractice';
import { IFile } from '../fileTree/IFileTree';
import { Colors } from '../../../color/Colors';
import { CUSTOM_THEME_NAME, defineAppTheme } from '../../monacoTheme';

export interface IReviewEditorProps {
  file: IFile;
  currentOption: IPrimitiveStore<IFileOption>;
  lang: ITaskLanguage;
  height: number;
}

export const ReviewEditor = observer(
  ({ file, currentOption, lang, height }: IReviewEditorProps) => {
    const editorHeight = height > 0 ? height : 280;

    return (
      <Box sx={{ display: 'flex', width: '100%', height: '100%', overflow: 'hidden' }}>
        {file !== null && !file.hasOwnProperty('children') && (
          <Box sx={{ width: currentOption.value !== null ? '50%' : '100%', overflow: 'hidden', borderRight: currentOption.value !== null ? `1px solid ${Colors.border}` : 'none' }}>
            <Editor
              language={lang.name}
              theme={CUSTOM_THEME_NAME}
              beforeMount={defineAppTheme}
              height={editorHeight}
              value={file.value}
              options={{ minimap: { enabled: false }, automaticLayout: true }}
              onChange={(value) => {
                file.value = value;
              }}
            />
          </Box>
        )}
        {file !== null && !file.hasOwnProperty('children') && currentOption.value !== null && (
          <Box sx={{ width: '50%', overflow: 'hidden' }}>
            <Editor
              language={lang.name}
              theme={CUSTOM_THEME_NAME}
              beforeMount={defineAppTheme}
              height={editorHeight}
              value={currentOption.value.value}
              onChange={(newValue) => {
                if (newValue !== undefined) {
                  currentOption.value.value = newValue;
                }
              }}
              options={{ minimap: { enabled: false }, automaticLayout: true }}
            />
          </Box>
        )}
      </Box>
    );
  },
);
